import { render, staticRenderFns } from "./addorupdatetripdays.vue?vue&type=template&id=c8e79eec"
import script from "./addorupdatetripdays.vue?vue&type=script&lang=js"
export * from "./addorupdatetripdays.vue?vue&type=script&lang=js"
import style0 from "./addorupdatetripdays.vue?vue&type=style&index=0&id=c8e79eec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports